var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4137 4.71881L19.119 4.05252L21.2528 7.64146L19.8388 8.71201C19.091 9.27816 18.7815 10.177 18.7815 11C18.7815 11.834 19.1027 12.7227 19.8437 13.2893L21.2414 14.358L19.1073 17.9475L17.4079 17.2835C16.5459 16.9467 15.6329 17.11 14.9078 17.5238C14.1712 17.9441 13.524 18.6753 13.3855 19.6257L13.1415 21.3H8.84669L8.60361 19.6317C8.46481 18.6791 7.82027 17.946 7.0811 17.5216C6.35727 17.106 5.4444 16.9459 4.58629 17.2812L2.88096 17.9475L0.747193 14.3585L2.16126 13.288C2.90906 12.7218 3.21853 11.823 3.21853 11C3.21853 10.1945 2.94354 9.28644 2.18317 8.71077L0.770476 7.64125L2.89295 4.05261L4.60004 4.71959C5.45405 5.05326 6.36107 4.90187 7.08756 4.48326C7.82501 4.05833 8.47652 3.32134 8.61566 2.36642L8.85847 0.7H13.1533L13.3964 2.36828C13.5352 3.32085 14.1797 4.05401 14.9189 4.4784C15.6427 4.89399 16.5556 5.05409 17.4137 4.71881ZM6.05926 11C6.05926 13.6735 8.29938 15.825 11 15.825C13.7006 15.825 15.9407 13.6735 15.9407 11C15.9407 8.32652 13.7006 6.175 11 6.175C8.29938 6.175 6.05926 8.32652 6.05926 11Z",
    stroke: "#606060",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetting);
export default __webpack_public_path__ + "static/media/ic_setting.bae631fe2fcb3027f4d6fab791a1bb50.svg";
export { ForwardRef as ReactComponent };